var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, ViewChild, PropertyConverters, Components, Utils, PropertyChangeEvent, Animations } from '@pacem/pacem-core';
import { AdapterOrientation } from './adapter';
//namespace Pacem.Components.UI {
const PACEM_TAB_FOCUS_CSS = 'tab-focus';
const StringOrNodePropertyConverter = {
    convert: (attr, e) => {
        return attr.startsWith('#') ? PropertyConverters.Element.convert(attr, e) : PropertyConverters.String.convert(attr, e);
    },
    convertBack: (prop, e) => {
        return (prop instanceof Node) ? PropertyConverters.Element.convertBack(prop, e) : PropertyConverters.String.convertBack(prop, e);
    },
    retryConversionWhenReady: true
};
let PacemTabElement = class PacemTabElement extends Components.PacemIterableElement {
    constructor() {
        super('tab');
        this._slotChangeHandler = (_) => {
            const old = this.#content;
            const val = this.#content = this.content;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'content', currentValue: val, oldValue: old }));
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._slotLabel.addEventListener('slotchange', this._slotChangeHandler, false);
    }
    disconnectedCallback() {
        const lbl = this._slotLabel;
        if (!Utils.isNull(lbl)) {
            lbl.removeEventListener('slotchange', this._slotChangeHandler, false);
        }
        super.disconnectedCallback();
    }
    #content;
    get content() {
        return this.querySelectorAll('*[slot=label]');
    }
};
__decorate([
    ViewChild('slot[name=label]')
], PacemTabElement.prototype, "_slotLabel", void 0);
__decorate([
    Watch({ converter: StringOrNodePropertyConverter })
], PacemTabElement.prototype, "label", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemTabElement.prototype, "key", void 0);
PacemTabElement = __decorate([
    CustomElement({
        tagName: P + '-tab', shadow: true, template: `<slot name="label" part="label"></slot><slot></slot>`
    })
], PacemTabElement);
export { PacemTabElement };
let PacemTabsElement = class PacemTabsElement extends Components.PacemIterativeElement {
    constructor(_tweener = new Animations.TweenService()) {
        super("tablist");
        this._tweener = _tweener;
    }
    _labelCallback(item, index) {
        const content = item.content;
        if (content.length > 0) {
            let assembled = '';
            content.forEach((node) => {
                assembled += node.outerHTML;
            });
            return assembled;
        }
        if (item.label instanceof Node) {
            return item.label;
        }
        return `<span class="${(item.key || 'tab')}">${item.label}</span>`;
    }
    _syncOrientation(val = this.orientation) {
        if (!Utils.isNull(this._defaultTabAdapter)) {
            this._defaultTabAdapter.orientation = val;
        }
        if (!Utils.isNull(this._tabs)) {
            const fn = val === AdapterOrientation.Vertical ? Utils.addClass : Utils.removeClass;
            fn(this._tabs, 'tabs-vertical');
        }
    }
    _syncVisibility(val = this.index, old = -1) {
        const timeout = 500;
        // lock height
        const container = this._container, height = container.clientHeight;
        const style = getComputedStyle(container), padding = style.boxSizing === 'border-box' ? 0 : parseInt(style.paddingTop) + parseInt(style.paddingBottom);
        container.style.height = (height - padding) + 'px';
        let ndx = 0;
        for (let tab of this.items || []) {
            if (ndx === val) {
                Utils.addClass(tab, 'tab-in');
                requestAnimationFrame(() => {
                    // wait for visibility digestion
                    Utils.addClass(tab, PACEM_TAB_FOCUS_CSS);
                    Utils.removeClass(tab, 'tab-in');
                    Utils.addAnimationEndCallback(tab, (t) => {
                        Utils.removeClass(t, 'tab-previous tab-next');
                        const tgetH = Utils.offset(t).height /* + padding*/;
                        this._tweener.run(parseInt(container.style.height), tgetH, 100, 0, Animations.Easings.sineOut, (_, v) => {
                            container.style.height = Math.round(v) + 'px';
                        })
                            .then(_ => {
                            // unlock height
                            container.style.height = '';
                        });
                    }, timeout);
                });
                tab.aria.attributes.set('selected', 'true');
            }
            else {
                Utils.removeClass(tab, 'tab-previous tab-next');
                Utils.addClass(tab, ndx < val ? 'tab-previous' : 'tab-next');
                if (ndx === old) {
                    Utils.addClass(tab, 'tab-out');
                    Utils.removeClass(tab, PACEM_TAB_FOCUS_CSS);
                    Utils.addAnimationEndCallback(tab, (t) => {
                        Utils.removeClass(t, 'tab-out');
                    }, timeout);
                    tab.aria.attributes.set('selected', 'false');
                }
            }
            ndx++;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        //this._defaultTabAdapter.labelCallback = this._labelCallback;
        if (Utils.isNull(this.adapter)) {
            this._syncOrientation();
            this._syncVisibility();
            this.adapter = this._defaultTabAdapter;
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'adapter':
                if (Utils.isNull(val)) {
                    this.adapter = this._defaultTabAdapter;
                }
                this._isUsingDefaultTabAdapter = this.adapter === this._defaultTabAdapter;
                break;
            case 'index':
                this._syncVisibility(val, old);
                break;
            case 'orientation':
                this._syncOrientation(val);
                break;
        }
    }
    validate(item) {
        return item instanceof PacemTabElement;
    }
};
__decorate([
    ViewChild(P + '-adapter')
], PacemTabsElement.prototype, "_defaultTabAdapter", void 0);
__decorate([
    ViewChild('.' + PCSS + '-tabs')
], PacemTabsElement.prototype, "_tabs", void 0);
__decorate([
    ViewChild('.' + PCSS + '-tabs-content')
], PacemTabsElement.prototype, "_container", void 0);
__decorate([
    Watch()
], PacemTabsElement.prototype, "_isUsingDefaultTabAdapter", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemTabsElement.prototype, "orientation", void 0);
PacemTabsElement = __decorate([
    CustomElement({
        tagName: P + '-tabs', shadow: false,
        template: `<div class="${PCSS}-tabs">
    <${P}-adapter class="${PCSS}-tabs-adapter" swipe-enabled="false" hide="{{ !:host._isUsingDefaultTabAdapter }}" label-callback="{{ :host._labelCallback }}"></${P}-adapter>
    <div class="${PCSS}-tabs-content">
        <${P}-content></${P}-content>
    </div>
</div>`
    })
], PacemTabsElement);
export { PacemTabsElement };
